/*
 * @Author: wangweixin
 * @Date: 2017-12-15 11:02:29
 * @Last Modified by: wangweixin
 * @Last Modified time: 2020-05-14 16:00:22
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import iconChecked from './images/radio_active.svg';
import iconBase from './images/radio.svg';
import Icon from '../Icon';
import { nfn } from '../../common';

/**
 * 对Radio进行简单的封装
 * 并没有进行样式的修改
 */
export default function Radio({
  defaultChecked,
  onChange,
  label,
  value,
  disabled,
  mini,
  className,
  ...others
}) {
  const classes = classNames('radio-label', className, {
    disabled,
    mini
  });
  return (
    <label key={`radio-label-${value}`} className={classes}>
      <Icon
        className="radio-icon"
        link={defaultChecked ? iconChecked : iconBase}
      />
      <input
        className="radio"
        type="radio"
        checked={defaultChecked}
        value={value}
        disabled={disabled}
        onChange={e =>
          onChange(e.target.checked, value, { checked: e.target.checked })
        }
      />
      {label}
    </label>
  );
}
Radio.defaultProps = {
  onChange: nfn
};
Radio.propTypes = {
  /** radio标签描述 */
  label: PropTypes.string,
  /** 是否默认选中 */
  defaultChecked: PropTypes.bool,
  /** 该选项对应的值，会在onChange时传入回调 */
  value: PropTypes.any,
  /** 值更改时的回调 */
  onChange: PropTypes.func,
  /** 禁用状态 */
  disabled: PropTypes.bool
};
